import { render, staticRenderFns } from "./RecipientCard.vue?vue&type=template&id=fe2be70a&scoped=true&"
import script from "./RecipientCard.vue?vue&type=script&lang=js&"
export * from "./RecipientCard.vue?vue&type=script&lang=js&"
import style0 from "./RecipientCard.vue?vue&type=style&index=0&id=fe2be70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2be70a",
  null
  
)

export default component.exports